import { SmartViewKind } from "@/domains/smart/constants";

type PayloadArgs = {
  spaceAccountId: string | null;
  smartViewKind?: SmartViewKind | null;
  activeNoteId?: string | null;
  query?: string | null;
};

export function buildSmartViewPayload({
  spaceAccountId,
  smartViewKind = SmartViewKind.HeadsUp,
  activeNoteId = null,
  query = null,
}: PayloadArgs): Record<string, unknown> {
  const payload: Record<string, unknown> = {};

  if (spaceAccountId) {
    payload.space_account_id = spaceAccountId;
  }

  if (smartViewKind) {
    payload.smart_view_kind = smartViewKind;
  }

  if (activeNoteId) {
    payload.active_note_id = activeNoteId;
  }

  if (query) {
    payload.query = query;
  }

  return payload;
}
